// extracted by mini-css-extract-plugin
module.exports = {"comingsoon":"NewsTab_comingsoon_2HwRX"};